// extracted by mini-css-extract-plugin
export default {"container":"task-tag_container__aKvrj","content":"task-tag_content__MCrm4"};